import { accountsService } from './accountsService';

/** Restaurant staff lookups over the unified accounts list, scoped to the caller's restaurants. */
export const staffService = {
  // Staff for a restaurant, with pageSize bumped so one call covers typical staff counts without paging.
  list: async (restaurantId, { pageSize = 500 } = {}) => {
    const data = await accountsService.list({ type: 'staff', pageSize });
    const rows = data?.results || [];
    return restaurantId
      ? rows.filter((s) => String(s.restaurant_id) === String(restaurantId))
      : rows;
  },
};

export default staffService;
